/*
  SylverCar — module de panier.

  Principe directeur, impose par le brief : AMELIORATION PROGRESSIVE.
  Le site fonctionne sans ce fichier. Les formulaires d'ajout sont natifs et
  pointent vers /cart/add, l'icone du header est un vrai lien vers /cart.
  Ce module se contente d'intercepter ces actions QUAND il y parvient. Toute
  erreur — reseau, JSON, exception — laisse le comportement natif reprendre
  la main plutot que d'afficher un panier a moitie fonctionnel.

  Source unique de verite : l'API panier de Shopify. Aucun etat parallele.
*/
(function () {
  'use strict';

  var racine = document.querySelector('[data-sc-panier]');
  if (!racine) return;

  var PALIER_CADEAU = parseInt(racine.getAttribute('data-palier-cadeau'), 10) || 0;
  var PALIER_REMISE = parseInt(racine.getAttribute('data-palier-remise'), 10) || 0;
  var FORMAT = racine.getAttribute('data-format-monnaie') || '{{amount}} €';
  var URL_PANIER = racine.getAttribute('data-url-panier') || '/cart';
  var REMISE_MONTANT = parseInt(racine.getAttribute('data-remise-montant'), 10) || 0;
  var COLLECTIONS_CADEAU = (racine.getAttribute('data-cadeau-collections') || '')
    .split(',').filter(function (h) { return h; });
  var PLAFOND_CADEAU = parseInt(racine.getAttribute('data-cadeau-plafond'), 10) || 0;

  // Marqueur pose sur la ligne du cadeau. C'est lui, et non l'identite du
  // produit, qui distingue le cadeau d'un article que le client aurait
  // volontairement achete dans les memes collections : quelqu'un peut tres
  // bien vouloir payer un sticker en plus de celui qu'on lui offre.
  var MARQUE_CADEAU = '_Cadeau';

  var corps = racine.querySelector('[data-sc-panier-corps]');
  var liste = racine.querySelector('[data-sc-panier-liste]');
  var vide = racine.querySelector('[data-sc-panier-vide]');
  var pied = racine.querySelector('[data-sc-panier-pied]');
  var paliers = racine.querySelector('[data-sc-panier-paliers]');
  var compte = racine.querySelector('[data-sc-panier-compte]');
  var bulle = racine.querySelector('[data-sc-bulle]');
  var bulleCompte = racine.querySelector('[data-sc-bulle-compte]');

  var enCours = false;   // anti double-clic / double-ajout
  var cadeauEnCours = false;  // evite que la gestion du cadeau se rappelle elle-meme
  var dernierPanier = null;   // dernier etat rendu, pour cocher le cadeau en cours
  var dernierFocus = null;

  /* ------------------------------------------------------------------ */
  /* Formatage monetaire                                                 */
  /* ------------------------------------------------------------------ */
  // On reproduit le format de la boutique plutot que d'imposer le notre :
  // le total du tiroir doit correspondre au centime pres a celui du checkout.
  // Shopify propose cinq marqueurs de format. Cette boutique utilise
  // {{amount_with_comma_separator}}. On les gere tous plutot que de
  // supposer : un total different de celui du checkout est inacceptable.
  function prix(centimes) {
    var n = centimes / 100;
    var grouper = function (entier, sep) {
      return entier.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    };
    var avecDecimales = function (sepDecimal, sepMillier) {
      var parts = n.toFixed(2).split('.');
      return grouper(parts[0], sepMillier) + sepDecimal + parts[1];
    };
    var sansDecimales = function (sepMillier) {
      return grouper(Math.round(n).toString(), sepMillier);
    };
    var valeurs = {
      amount: avecDecimales('.', ','),
      amount_no_decimals: sansDecimales(','),
      amount_with_comma_separator: avecDecimales(',', '.'),
      amount_no_decimals_with_comma_separator: sansDecimales('.'),
      amount_with_apostrophe_separator: avecDecimales('.', String.fromCharCode(39))
    };
    var sortie = FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (tout, cle) {
      return Object.prototype.hasOwnProperty.call(valeurs, cle) ? valeurs[cle] : tout;
    });
    // Aucun marqueur reconnu : on rend un montant brut plutot que rien.
    return sortie === FORMAT ? valeurs.amount_with_comma_separator + ' €' : sortie;
  }

  /* ------------------------------------------------------------------ */
  /* Appels a l'API panier                                               */
  /* ------------------------------------------------------------------ */
  function appel(url, corpsRequete) {
    var options = {
      method: corpsRequete ? 'POST' : 'GET',
      // En-tete de reconnaissance : le filet reseau pose plus bas doit
      // pouvoir distinguer nos appels de ceux des applications tierces,
      // sinon il se declencherait sur lui-meme.
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-SylverCar-Panier': '1'
      },
      credentials: 'same-origin'
    };
    if (corpsRequete) options.body = JSON.stringify(corpsRequete);
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error('reponse ' + r.status);
      return r.json();
    });
  }

  var lire = function () { return appel('/cart.js'); };
  var ajouter = function (items) { return appel('/cart/add.js', { items: items }); };
  var changer = function (cle, quantite) {
    return appel('/cart/change.js', { id: cle, quantity: quantite });
  };

  /* ------------------------------------------------------------------ */
  /* Rendu                                                               */
  /* ------------------------------------------------------------------ */
  function ligne(article) {
    var li = document.createElement('li');
    // Le cadeau ne se manipule pas : ni quantite, ni suppression. Il est la
    // consequence du palier, pas un achat. Le retirer a la main le ferait
    // revenir a la synchronisation suivante, ce qui serait incomprehensible.
    var estCadeau = !!(article.properties && article.properties[MARQUE_CADEAU]);
    // Tant que la remise n'est pas la, on n'ecrit pas « Offert » sur une
    // ligne que le client paierait. Le tiroir montre ce qui est, jamais ce
    // qui devrait etre.
    var cadeauOffert = estCadeau && cadeauEffectivementOffert(article);
    // Cadeau conserve mais paye, parce qu'une remise de commande plus
    // avantageuse l'a emporte. On ne dit ni « offert » — ce serait faux —
    // ni rien : on montre son prix, et le recapitulatif affiche la remise
    // qui le couvre largement.
    var cadeauCouvert = estCadeau && !cadeauOffert;
    li.className = 'sc-article' + (estCadeau ? ' sc-article--cadeau' : '');
    li.setAttribute('data-cle', article.key);

    var image = article.image
      ? article.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
      : '';

    // La variante n'est affichee que si elle existe reellement : Shopify
    // renvoie « Default Title » pour les produits sans declinaison.
    var variante = article.variant_title && article.variant_title !== 'Default Title'
      ? '<span class="sc-article__variante">' + echapper(article.variant_title) + '</span>'
      : '';

    li.innerHTML =
      '<div class="sc-article__visuel">' +
        (image ? '<img src="' + image + '" alt="" width="80" height="80" loading="lazy">' : '') +
      '</div>' +
      '<div class="sc-article__infos">' +
        '<a class="sc-article__titre" href="' + article.url + '">' + echapper(article.product_title) + '</a>' +
        variante +
        '<div class="sc-article__bas">' +
          (estCadeau
            ? '<span class="sc-article__offert">' + (cadeauOffert ? 'Offert' : 'Cadeau choisi') + '</span>' +
              '<button type="button" class="sc-article__changer" data-sc-changer-cadeau>Changer</button>'
            : '<div class="sc-article__quantite">' +
                '<button type="button" data-sc-qte="-1" aria-label="Diminuer la quantité">−</button>' +
                '<span data-sc-qte-valeur>' + article.quantity + '</span>' +
                '<button type="button" data-sc-qte="1" aria-label="Augmenter la quantité">+</button>' +
              '</div>') +
          '<span class="sc-article__prix">' + (cadeauOffert ? 'Cadeau' : prix(article.final_line_price)) + '</span>' +
        '</div>' +
      '</div>' +
      (estCadeau ? '' :
        '<button type="button" class="sc-article__retirer" data-sc-retirer aria-label="Retirer cet article">' +
          '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '</button>');
    return li;
  }

  function echapper(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  // Etat des paliers au rendu precedent. Sert uniquement a distinguer un
  // palier FRANCHI a l'instant d'un palier deja acquis : on ne fete que le
  // franchissement, sinon l'animation se rejouerait a chaque changement de
  // quantite et deviendrait du bruit.
  var paliersPrecedents = null;

  var ICONE_CADEAU = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 7h12v7H2zM1 4.5h14V7H1zM8 4.5V14M8 4.5S6.8 1.8 5.2 2.2C3.9 2.5 4.1 4.5 5.6 4.5zM8 4.5s1.2-2.7 2.8-2.3c1.3.3 1.1 2.3-.4 2.3z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';
  var ICONE_REMISE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8.6 1.6H14v5.4L7.4 13.6a1.4 1.4 0 0 1-2 0L2.4 10.6a1.4 1.4 0 0 1 0-2z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="11" cy="4.6" r="1.1" fill="currentColor"/></svg>';
  var ICONE_COCHE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Les paliers sont des montants ronds : « 80,00€ » alourdit une etiquette
  // deja dense. On ne raccourcit que la, le message du reste a payer garde
  // ses centimes, lui, parce qu il en a rarement de nuls.
  function prixCourt(centimes) {
    return centimes % 100 === 0 ? prix(centimes).replace(/([.,])00/, '') : prix(centimes);
  }

  function rendrePaliers(total, cadeauObtenu, remiseAccordee) {
    if (!paliers || !PALIER_CADEAU) return;

    // Le premier jalon s'allume quand le cadeau est REELLEMENT au panier et
    // offert, pas quand le montant seul est atteint. Il existe une bande
    // etroite sous le second palier ou Shopify prefere la remise de commande
    // et refuse le cadeau : y afficher « cadeau debloque » alors que le
    // panier n'en contient aucun serait un mensonge, et le client le verrait.
    //
    // Sans vivier configure, il n'y a rien a obtenir : on retombe sur le
    // seul critere de montant.
    var montantAtteint = total >= PALIER_CADEAU;
    var atteintCadeau = COLLECTIONS_CADEAU.length ? (montantAtteint && cadeauObtenu) : montantAtteint;

    // La remise est annoncee comme acquise des que Shopify l'a REELLEMENT
    // appliquee, pas seulement quand notre propre calcul franchit le seuil.
    // Dans la bande sous le second palier, le cadeau non remis gonfle le
    // sous-total et Shopify accorde les 10 EUR en avance : les annoncer
    // « pas encore » alors qu'ils figurent au recapitulatif ferait douter
    // le client du total qu'on lui affiche.
    var atteintRemise = remiseAccordee || (PALIER_REMISE > 0 && total >= PALIER_REMISE);

    var message;
    if (!montantAtteint) {
      message = 'Plus que <strong>' + prix(PALIER_CADEAU - total) + '</strong> pour choisir votre cadeau 🎁';
    } else if (!atteintCadeau && PALIER_REMISE && !atteintRemise) {
      // Montant atteint mais cadeau refuse : les deux recompenses arrivent
      // ensemble au palier suivant. On l'annonce comme tel, c'est vrai et
      // c'est le meilleur argument qu'on ait.
      message = 'Plus que <strong>' + prix(PALIER_REMISE - total) + '</strong> pour votre cadeau et ' +
        prixCourt(REMISE_MONTANT) + ' de remise';
    } else if (PALIER_REMISE && !atteintRemise) {
      message = 'Votre cadeau est débloqué ! Plus que <strong>' + prix(PALIER_REMISE - total) +
        '</strong> pour obtenir ' + prixCourt(REMISE_MONTANT) + ' de remise';
    } else {
      message = 'Palier Privilège débloqué : ' + prixCourt(REMISE_MONTANT) + ' de remise sur votre commande';
    }

    // La barre couvre desormais tout le parcours, de 0 au dernier palier,
    // et non plus seulement l'etape en cours : c'est ce qui permet de voir
    // les deux marches d'un coup d'oeil et de mesurer le chemin restant.
    var maximum = PALIER_REMISE > PALIER_CADEAU ? PALIER_REMISE : PALIER_CADEAU;
    var pourcent = maximum ? Math.min(100, (total / maximum) * 100) : 0;
    var posCadeau = maximum ? (PALIER_CADEAU / maximum) * 100 : 100;

    var jalon = function (position, atteint, cle) {
      return '<span class="sc-paliers__jalon' + (atteint ? ' is--atteint' : '') +
        '" data-jalon="' + cle + '" style="left:' + position + '%"></span>';
    };
    var etiquette = function (position, atteint, cle, texte, montant, icone) {
      return '<span class="sc-paliers__etiquette' + (atteint ? ' is--atteint' : '') +
        '" data-etiquette="' + cle + '" style="left:' + position + '%">' +
        '<span class="sc-paliers__etiquette-icone">' + (atteint ? ICONE_COCHE : icone) + '</span>' +
        '<span class="sc-paliers__etiquette-txt">' + texte + '</span>' +
        '<span class="sc-paliers__etiquette-montant">' + montant + '</span>' +
      '</span>';
    };

    var piste = '<div class="sc-paliers__piste">' +
      '<span class="sc-paliers__jauge" style="width:' + pourcent.toFixed(1) + '%"></span>' +
      jalon(posCadeau, atteintCadeau, 'cadeau') +
      (PALIER_REMISE ? jalon(100, atteintRemise, 'remise') : '') +
    '</div>';

    var legende = '<div class="sc-paliers__legende">' +
      etiquette(posCadeau, atteintCadeau, 'cadeau', 'Cadeau', prixCourt(PALIER_CADEAU), ICONE_CADEAU) +
      (PALIER_REMISE ? etiquette(100, atteintRemise, 'remise', '\u2212' + prixCourt(REMISE_MONTANT), prixCourt(PALIER_REMISE), ICONE_REMISE) : '') +
    '</div>';

    paliers.innerHTML =
      '<p class="sc-paliers__texte' + (atteintCadeau ? ' is--atteint' : '') + '">' + message + '</p>' +
      piste + legende;
    paliers.hidden = false;

    feter(atteintCadeau, atteintRemise);
  }

  // Franchissement d'un palier : le texte seul ne se remarque pas. On marque
  // le coup sur le jalon concerne, une fois, brievement.
  function feter(atteintCadeau, atteintRemise) {
    var etat = { cadeau: atteintCadeau, remise: atteintRemise };

    // Premier rendu de la page : on prend l'etat tel quel sans rien feter,
    // sinon un visiteur qui revient avec un panier deja garni verrait une
    // celebration pour un palier franchi hier.
    if (paliersPrecedents === null) { paliersPrecedents = etat; return; }

    var nouveau = null;
    if (etat.remise && !paliersPrecedents.remise) nouveau = 'remise';
    else if (etat.cadeau && !paliersPrecedents.cadeau) nouveau = 'cadeau';
    paliersPrecedents = etat;
    if (!nouveau) return;

    var jalon = paliers.querySelector('[data-jalon="' + nouveau + '"]');
    var etiquette = paliers.querySelector('[data-etiquette="' + nouveau + '"]');
    paliers.classList.add('is--fete');
    if (jalon) jalon.classList.add('is--fete');
    if (etiquette) etiquette.classList.add('is--fete');

    clearTimeout(feter.minuteur);
    feter.minuteur = setTimeout(function () {
      paliers.classList.remove('is--fete');
      if (jalon) jalon.classList.remove('is--fete');
      if (etiquette) etiquette.classList.remove('is--fete');
    }, 1800);
  }

  function rendre(panier) {
    if (!panier) return;
    dernierPanier = panier;
    var n = panier.item_count;

    if (compte) compte.textContent = n ? ' (' + n + ')' : '';
    majCompteurTheme(n);

    // La pastille suit le panier : elle apparait au premier article et
    // disparait quand il n'en reste plus.
    if (bulle) bulle.hidden = !n;
    if (bulleCompte) bulleCompte.textContent = n || '';
    liste.innerHTML = '';

    if (!n) {
      if (vide) vide.hidden = false;
      if (pied) pied.hidden = true;
      if (paliers) paliers.hidden = true;
      recommander(panier);
      return;
    }
    if (vide) vide.hidden = true;
    if (pied) pied.hidden = false;

    for (var i = 0; i < panier.items.length; i++) liste.appendChild(ligne(panier.items[i]));

    // La barre mesure ce que le client a reellement depense, cadeau exclu,
    // et sait si le cadeau est effectivement acquis.
    //
    // Nom explicite et non « ligne » : une variable de ce nom masquerait la
    // fonction ligne() utilisee juste au-dessus pour construire chaque
    // article, et la boucle appellerait une valeur encore indefinie.
    var ligneDuCadeau = ligneCadeau(panier);
    var remiseAccordee = (panier.cart_level_discount_applications || []).length > 0;
    rendrePaliers(totalHorsCadeau(panier), !!ligneDuCadeau, remiseAccordee);

    // Si l'ajout ou le retrait du cadeau change le panier, on relit une fois
    // et on redessine. gererCadeau ne declenche rien quand l'etat est deja
    // le bon, il n'y a donc pas de boucle.
    gererCadeau(panier).then(function (change) {
      if (change) lire().then(rendre);
    });

    // Sous-total AVANT remises, et non items_subtotal_price qui les a deja
    // deduites. Sinon le resume ne s additionne pas sous les yeux du client :
    // il lirait 174,50 moins 10 moins 8,50 et trouverait 156, alors que le
    // total affiche 164,50. Un recapitulatif qui ne tombe pas juste fait
    // douter de tout le reste.
    var soustotalBrut = 0;
    for (var s = 0; s < panier.items.length; s++) {
      var it = panier.items[s];
      soustotalBrut += it.original_line_price != null ? it.original_line_price : it.final_line_price;
    }
    ecrire('[data-sc-panier-soustotal]', prix(soustotalBrut));
    ecrire('[data-sc-panier-total]', prix(panier.total_price));
    ecrire('[data-sc-panier-cta-total]', '· ' + prix(panier.total_price));

    recommander(panier);

    rendreReductions(panier);
  }


  // Le compteur du header est un element du theme, pas du tiroir. Kalles le
  // rafraichissait par son propre AJAX, que nous avons desactive : c'est
  // donc a nous de le tenir a jour. Sans cela le client ajoute un article,
  // voit une icone a zero, et recommence.
  //
  // t4s-op-0 est la classe d'opacite nulle du theme : c'est ainsi qu'il
  // masque la pastille quand le panier est vide.
  function majCompteurTheme(n) {
    var cibles = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].textContent = n;
      if (n > 0) cibles[i].classList.remove('t4s-op-0');
      else cibles[i].classList.add('t4s-op-0');
    }
  }


  // Reductions appliquees : on reprend les intitules de Shopify plutot que
  // d'en inventer. Le client doit lire dans le tiroir exactement ce qu'il
  // relira au checkout.
  function rendreReductions(panier) {
    var zone = racine.querySelector('[data-sc-panier-reductions]');
    if (!zone) return;

    var lignes = '';
    var total = 0;

    var niveauPanier = panier.cart_level_discount_applications || [];
    for (var i = 0; i < niveauPanier.length; i++) {
      var d = niveauPanier[i];
      var montant = d.total_allocated_amount || 0;
      if (montant <= 0) continue;
      total += montant;
      lignes += '<div class="sc-panier__ligne sc-panier__ligne--economie">' +
        '<dt>' + echapper(d.title || 'Réduction') + '</dt>' +
        '<dd>\u2212 ' + prix(montant) + '</dd>' +
      '</div>';
    }

    // Les remises de ligne (le cadeau, les offres groupees) sont regroupees :
    // les detailler une par une allongerait le resume sans rien apprendre.
    //
    // line_level_total_discount et NON total_discount : Shopify repartit la
    // remise de commande sur les lignes, et total_discount l inclut. On
    // l aurait alors comptee deux fois — une fois dans sa propre ligne, une
    // fois ici — et le client aurait lu une economie superieure a la realite.
    var surLignes = 0;
    for (var k = 0; k < panier.items.length; k++) {
      surLignes += panier.items[k].line_level_total_discount || 0;
    }
    if (surLignes > 0) {
      total += surLignes;
      lignes += '<div class="sc-panier__ligne sc-panier__ligne--economie">' +
        '<dt>Remises sur articles</dt>' +
        '<dd>\u2212 ' + prix(surLignes) + '</dd>' +
      '</div>';
    }

    zone.innerHTML = lignes;
    zone.hidden = total <= 0;
  }

  function ecrire(selecteur, texte) {
    var el = racine.querySelector(selecteur);
    if (el) el.textContent = texte;
  }

  /* ------------------------------------------------------------------ */
  /* Ouverture / fermeture                                               */
  /* ------------------------------------------------------------------ */
  function ouvrir() {
    dernierFocus = document.activeElement;
    racine.classList.add('is--ouvert');
    racine.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sc-panier-ouvert');
    var f = racine.querySelector('[data-sc-panier-fermer]');
    if (f) f.focus();
  }

  function fermer() {
    fermerCadeaux();
    racine.classList.remove('is--ouvert');
    racine.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sc-panier-ouvert');
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function rafraichirPuisOuvrir() {
    return lire().then(function (p) { rendre(p); ouvrir(); });
  }

  /* ------------------------------------------------------------------ */
  /* Interception — delegation globale, jamais de liaison par element     */
  /* ------------------------------------------------------------------ */
  // Kalles pose ses propres gestionnaires sur le CLIC des boutons d ajout,
  // et fait son appel reseau sans jamais laisser le formulaire emettre
  // d evenement submit. On se place donc en phase de CAPTURE sur le
  // document, qui s execute avant tout gestionnaire pose plus bas dans
  // l arbre, et on stoppe la propagation pour rester seul maitre du panier.
  //
  // Le bouton de paiement express est volontairement exclu : il mene
  // directement au checkout, ce n est pas un ajout au panier.
  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    if (cible.closest('.shopify-payment-button')) return;

    var bouton = cible.closest('[name="add"], [data-atc-form], button[type="submit"]');
    if (!bouton) return;
    var form = bouton.form || bouton.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;

    // Une offre groupee n'est pas un ajout ordinaire : sur les produits
    // WideBundle, choisir « 2 housses » doit mettre DEUX variantes au panier
    // au prix degressif. Or notre interception s'execute avant celle de
    // WideBundle et coupe la propagation : sans ce garde-fou, le client
    // choisissait deux housses et n'en recevait qu'une, facturee au prix
    // unitaire. Une commande fausse coute infiniment plus cher qu'un tiroir
    // qui ne s'ouvre pas.
    if (wideBundlePiloteLeClic()) return;

    e.preventDefault();
    e.stopPropagation();
    soumettre(form);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (enCours) { e.preventDefault(); return; }

    e.preventDefault();
    soumettre(form);
  }, true);


  // WideBundle a trois comportements apres ajout, regles dans son admin :
  //
  //   link_choice = 'cart'     -> il ajoute lui-meme puis va sur /cart
  //   link_choice = 'checkout' -> il ajoute lui-meme puis va au paiement
  //   link_choice = 'form'     -> il injecte ses variantes dans le
  //                               formulaire du theme et nous laisse faire
  //
  // Dans les deux premiers cas il est seul maitre du clic et nous devons
  // nous effacer, quitte a subir sa redirection : notre filet reseau verra
  // quand meme passer l'ajout. Dans le troisieme, le formulaire porte
  // toutes les variantes et notre interception les reprend integralement.
  //
  // La lecture se fait a chaque clic, jamais mise en cache : le jour ou le
  // reglage change dans l'application, ce code suit sans redeploiement.
  function wideBundlePiloteLeClic() {
    var wb = window.wideBundle;
    if (!wb || !wb.settings) return false;
    // WideBundle n'est en jeu que la ou il a effectivement pose ses offres.
    if (!document.querySelector('.new-form-option')) return false;

    // On re-affirme le mode ici : si l'application avait recharge son
    // reglage depuis le serveur entre le chargement et le clic, le forcage
    // initial serait perdu et le client repartirait vers /cart.
    if (wb.settings.link_choice !== 'form') wb.settings.link_choice = 'form';
    return false;
  }
  function soumettre(form) {
    if (enCours) return;
    var donnees = new FormData(form);

    // Un formulaire d'ajout ne porte pas toujours UNE variante. WideBundle,
    // quand il est regle pour rester sur la page, transforme le champ id du
    // theme en liste : une offre « 2 housses » injecte deux identifiants
    // dans le meme formulaire. Ne lire que le premier reviendrait a livrer
    // une housse a quelqu'un qui en a paye deux.
    var identifiants = donnees.getAll('id').filter(function (v) { return v; });
    var quantites = donnees.getAll('quantity').filter(function (v) { return v; });

    // Sans identifiant de variante on ne tente rien : le navigateur
    // saura faire mieux que nous avec le formulaire natif.
    if (!identifiants.length) { form.__scRepli = true; form.submit(); return; }

    // Les proprietes de ligne s'appliquent a toutes les variantes du
    // formulaire, comme le fait Shopify avec ce format.
    var proprietes = null;
    donnees.forEach(function (valeur, cle) {
      if (cle.indexOf('properties[') === 0) {
        proprietes = proprietes || {};
        proprietes[cle.slice(11, -1)] = valeur;
      }
    });

    var items = identifiants.map(function (id, rang) {
      // Une seule quantite pour plusieurs variantes : elle vaut pour toutes.
      var brute = quantites.length > 1 ? quantites[rang] : quantites[0];
      var article = { id: id, quantity: parseInt(brute, 10) || 1 };
      if (proprietes) article.properties = proprietes;
      return article;
    });

    enCours = true;
    verrouiller(form, true);

    ajouter(items)
      .then(rafraichirPuisOuvrir)
      .catch(function () {
        // Echec reseau ou refus du serveur : on rend la main au
        // comportement natif plutot que de laisser le visiteur bloque.
        // Le marqueur evite que le detournement de submit() nous renvoie
        // ici en boucle : ce repli-la doit vraiment quitter la page.
        form.__scRepli = true;
        form.submit();
      })
      .then(function () { enCours = false; verrouiller(form, false); });
  }

  function verrouiller(form, etat) {
    var b = form.querySelector('[type="submit"], [name="add"]');
    if (b) { b.disabled = etat; b.classList.toggle('is--chargement', etat); }
  }

  // Icone panier du header : reste un vrai lien vers /cart dans le HTML, on
  // n'annule la navigation qu'au moment du clic. Comme pour l'ajout, Kalles
  // pose son propre gestionnaire sur ce lien (data-drawer-options) pour
  // ouvrir SON tiroir : on passe donc en phase de capture et on coupe la
  // propagation, sinon les deux tiroirs s'ouvriraient l'un sur l'autre.
  //
  // Clic milieu, Cmd/Ctrl/Maj : on ne touche a rien, le visiteur veut un
  // nouvel onglet et doit l'obtenir.
  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('a[href$="/cart"], a[href*="/cart?"]') : null;
    if (!lien) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    rafraichirPuisOuvrir().catch(function () { window.location.href = URL_PANIER; });
  }, true);

  // Quantites, suppression, fermeture.
  racine.addEventListener('click', function (e) {
    var cible = e.target;
    if (cible.closest('[data-sc-panier-fermer]') || cible.closest('[data-sc-panier-voile]')) {
      fermer();
      return;
    }
    if (cible.closest('[data-sc-bulle]')) {
      // On relit avant d'ouvrir : le panier a pu changer dans un autre
      // onglet depuis le chargement de la page.
      rafraichirPuisOuvrir().catch(function () { window.location.href = URL_PANIER; });
      return;
    }
    if (cible.closest('[data-sc-changer-cadeau]')) {
      rendreCadeaux(dernierPanier);
      ouvrirCadeaux();
      return;
    }
    if (cible.closest('[data-sc-cadeaux-retour]')) { fermerCadeaux(); return; }

    var onglet = cible.closest('[data-sc-cadeaux-onglet]');
    if (onglet) {
      familleActive = parseInt(onglet.getAttribute('data-sc-cadeaux-onglet'), 10) || 0;
      rendreCadeaux(dernierPanier);
      return;
    }

    var carteCadeau = cible.closest('[data-sc-cadeau]');
    if (carteCadeau) {
      var variante = carteCadeau.getAttribute('data-sc-cadeau');
      chargerVivier().then(function (familles) {
        var fam = familles[parseInt(carteCadeau.getAttribute('data-famille'), 10) || 0];
        if (!fam) return;
        for (var i = 0; i < fam.produits.length; i++) {
          if (String(fam.produits[i].variante) === String(variante)) {
            echangerCadeau(fam.produits[i]);
            fermerCadeaux();
            return;
          }
        }
      });
      return;
    }

    var reco = cible.closest('[data-sc-reco]');
    if (reco) {
      ajouterReco(reco.getAttribute('data-sc-reco'), reco);
      return;
    }

    var art = cible.closest('[data-cle]');
    if (!art) return;
    var cle = art.getAttribute('data-cle');

    if (cible.closest('[data-sc-retirer]')) {
      majQuantite(cle, 0);
      return;
    }
    var bouton = cible.closest('[data-sc-qte]');
    if (bouton) {
      var actuel = parseInt(art.querySelector('[data-sc-qte-valeur]').textContent, 10) || 1;
      majQuantite(cle, actuel + parseInt(bouton.getAttribute('data-sc-qte'), 10));
    }
  });

  function majQuantite(cle, quantite) {
    if (enCours) return;
    enCours = true;
    racine.classList.add('is--occupe');
    changer(cle, Math.max(0, quantite))
      .then(rendre)
      .catch(function () { window.location.href = URL_PANIER; })
      .then(function () { enCours = false; racine.classList.remove('is--occupe'); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Echap referme d'abord le panneau de cadeaux : fermer tout le tiroir
    // ferait perdre au client bien plus que ce qu'il voulait quitter.
    if (zoneCadeaux && zoneCadeaux.classList.contains('is--ouvert')) { fermerCadeaux(); return; }
    if (racine.classList.contains('is--ouvert')) fermer();
  });


  /* ------------------------------------------------------------------ */
  /* Moteur de recommandations                                           */
  /* ------------------------------------------------------------------ */
  //
  // Trois pistes ont ete evaluees avant d'ecrire ceci :
  //
  //   - /recommendations/products.json?intent=complementary : renvoie vide,
  //     il faudrait appairer les produits un a un sur plus de 500 references.
  //   - ?intent=related : fonctionne, mais ne propose que des quasi-substituts
  //     (a un coussin lombaire il repond d'autres coussins lombaires). Sans
  //     valeur pour le panier moyen : on n'achete pas deux fois le meme objet.
  //   - /collections/<handle>/products.json : donne prix, stock, variante et
  //     visuel, et ne se recupere qu'a l'ouverture du tiroir. Retenu.
  //
  // La complementarite est donc decrite ici, en metier plutot qu'en
  // algorithme. L'ordre des familles compte : la premiere qui correspond
  // gagne, et 'housse' passe avant 'coussin' car un titre de housse
  // mentionne souvent les deux.
  var FAMILLES = [
    { motif: /housse/,
      cibles: ['coussin-lombaire-voiture', 'organisateur-de-siege-voiture', 'coussin-ceinture-de-securite'] },
    { motif: /coussin|assise|lombaire|dorsal|coccyx|sciatique|nuque|appui.?tete|repose.?tete/,
      cibles: ['appui-tete-voiture', 'housse-de-protection-siege-voiture', 'coussin-ceinture-de-securite'] },
    { motif: /organisateur|rangement|coffre|poubelle/,
      cibles: ['poubelle-de-voiture', 'supports-telephone-voiture', 'organisateur-de-siege-voiture'] },
    { motif: /desodorisant|diffuseur|parfum|senteur|odeur/,
      cibles: ['figurine-voiture', 'diffuseur-voiture', 'decoration-voiture'] },
    { motif: /support|telephone|chargeur|transmetteur|bluetooth/,
      cibles: ['transmetteur-bluetooth-voiture', 'organisateur-de-voiture', 'supports-telephone-voiture'] },
    { motif: /pare.?soleil|rideau|store/,
      cibles: ['rideau-voiture', 'pare-soleil-voiture-bebe', 'pare-soleil-voiture'] },
    { motif: /aspirateur|nettoyage|entretien|lavage|nettoyant/,
      cibles: ['nettoyage-voiture', 'poubelle-de-voiture', 'aspirateurs-voiture'] },
    { motif: /accoudoir|console/,
      cibles: ['console-accessoires-voiture', 'supports-telephone-voiture', 'organisateur-de-voiture'] }
  ];
  var REPLI = 'meilleurs-ventes';

  var zoneReco = racine.querySelector('[data-sc-panier-upsell]');
  var cacheCollections = {};   // handle -> produits normalises
  var recoEnCours = false;

  function familleDe(panier) {
    // On lit le handle ET le titre : le handle est le plus fiable sur cette
    // boutique (il decrit le produit en toutes lettres), le titre rattrape
    // les rares handles ecourtes.
    var texte = '';
    for (var i = 0; i < panier.items.length; i++) {
      texte += ' ' + (panier.items[i].handle || '') + ' ' + (panier.items[i].product_title || '');
    }
    texte = texte.toLowerCase();
    for (var f = 0; f < FAMILLES.length; f++) {
      if (FAMILLES[f].motif.test(texte)) return FAMILLES[f].cibles.concat([REPLI]);
    }
    return [REPLI];
  }

  function chargerCollection(handle) {
    if (cacheCollections[handle]) return Promise.resolve(cacheCollections[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=12', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var sortie = [];
        var liste = j.products || [];
        for (var i = 0; i < liste.length; i++) {
          var prod = liste[i];
          // Premiere variante DISPONIBLE, pas la premiere tout court : un
          // produit dont le coloris de tete est epuise reste vendable.
          var v = null;
          var dispos = prod.variants || [];
          for (var d = 0; d < dispos.length; d++) {
            if (dispos[d].available) { v = dispos[d]; break; }
          }
          if (!v) continue;
          var centimes = Math.round(parseFloat(v.price) * 100);
          if (!centimes) continue;
          sortie.push({
            id: prod.id,
            titre: prod.title,
            url: '/products/' + prod.handle,
            image: (prod.images && prod.images[0]) ? prod.images[0].src : '',
            variante: v.id,
            centimes: centimes,
            // Plusieurs variantes : on n'ajoute pas a l'aveugle une couleur
            // que le visiteur n'a pas choisie, on l'envoie sur la fiche.
            choixRequis: prod.variants.length > 1
          });
        }
        cacheCollections[handle] = sortie;
        return sortie;
      })
      .catch(function () { cacheCollections[handle] = []; return []; });
  }

  // Quel palier reste-t-il A CONQUERIR ? La question n'est pas seulement
  // « le montant est-il atteint », mais « la recompense est-elle deja dans
  // le panier ». Un article marque « Debloque votre cadeau » alors que le
  // cadeau y figure deja, ou « Debloque 10 EUR de remise » alors que la
  // remise est deja appliquee, fait douter le client de tout le reste.
  //
  // On lit donc l'etat reel du panier, pas seulement nos seuils.
  function ecartAuPalier(total, panier) {
    var cadeauDejaLa = panier ? !!ligneCadeau(panier) : false;
    var remiseDejaLa = panier ? ((panier.cart_level_discount_applications || []).length > 0) : false;

    if (PALIER_CADEAU && !cadeauDejaLa && total < PALIER_CADEAU) {
      return { montant: PALIER_CADEAU - total, libelle: 'D\u00e9bloque votre cadeau' };
    }
    if (PALIER_REMISE && !remiseDejaLa && total < PALIER_REMISE) {
      return { montant: PALIER_REMISE - total, libelle: 'D\u00e9bloque ' + prixCourt(REMISE_MONTANT) + ' de remise' };
    }
    return null;
  }

  // Certaines collections melangent des articles adulte et des articles
  // destines aux enfants ou aux animaux. Proposer un coussin enfant a
  // quelqu'un qui achete un coussin lombaire adulte fait perdre la
  // recommandation ET la credibilite du bloc. On les ecarte, sauf si le
  // panier montre justement cet interet-la.
  var PUBLIC_A_PART = /enfant|b[ée]b[ée]|kid|chien|animal/i;

  function choisir(candidats, panier) {
    var dansLePanier = {};
    var panierConcerne = false;
    for (var i = 0; i < panier.items.length; i++) {
      dansLePanier[panier.items[i].product_id] = true;
      var etiquette = (panier.items[i].product_title || '') + ' ' + (panier.items[i].handle || '');
      if (PUBLIC_A_PART.test(etiquette)) panierConcerne = true;
    }

    var pertinents = [];
    var ecartes = [];
    for (var c = 0; c < candidats.length; c++) {
      if (dansLePanier[candidats[c].id]) continue;
      if (!panierConcerne && PUBLIC_A_PART.test(candidats[c].titre)) ecartes.push(candidats[c]);
      else pertinents.push(candidats[c]);
    }

    // Les articles d'un autre public ne servent QUE de dernier recours.
    // Les melanger aux autres ne suffisait pas : le tri par prix les
    // ramenait en tete des qu'ils etaient les moins chers, et le filtre
    // n'avait plus aucun effet visible.
    var base = pertinents.length ? pertinents : ecartes;
    if (!base.length) return [];

    // L'ordre de `base` est l'ordre de pertinence : collection la plus
    // complementaire d'abord. C'est le classement par defaut.
    var ecart = ecartAuPalier(totalHorsCadeau(panier), panier);
    if (!ecart) {
      for (var z = 0; z < base.length; z++) delete base[z].note;
      return base.slice(0, 2);
    }

    // A prix voisin, on prefere un produit mono-variante : il s'ajoute sans
    // quitter le tiroir, la ou un multi-variante impose un detour par la
    // fiche. Voisin = moins de 5 euros d'ecart.
    var departage = function (a, b) {
      if (Math.abs(a.centimes - b.centimes) < 500 && a.choixRequis !== b.choixRequis) {
        return a.choixRequis ? 1 : -1;
      }
      return 0;
    };

    // Un palier est a portee : on met en tete l'article le MOINS cher qui le
    // franchit. Le moins cher et non le plus proche : franchir le palier en
    // depensant le minimum est ce qui se refuse le moins facilement.
    var franchissent = [];
    for (var k = 0; k < base.length; k++) {
      if (base[k].centimes >= ecart.montant) franchissent.push(base[k]);
    }
    franchissent.sort(function (a, b) { return departage(a, b) || (a.centimes - b.centimes); });

    // Les produits viennent du cache de collection et sont reutilises d'un
    // rendu a l'autre. Ecrire la mention dessus sans jamais l'effacer la
    // laissait collee : un article gardait « Debloque votre cadeau » alors
    // que le palier etait franchi depuis longtemps. On repart propre.
    for (var n = 0; n < base.length; n++) delete base[n].note;

    var tete = franchissent.length ? franchissent[0] : null;

    // La seconde place revient au candidat le plus pertinent restant, et
    // non a un second article trie par prix : l'ancienne version la
    // remplissait depuis les seuls articles NE franchissant PAS le palier,
    // liste vide des que l'ecart etait petit — le bloc n'affichait alors
    // qu'une seule proposition.
    var suite = [];
    for (var m = 0; m < base.length; m++) {
      if (base[m] !== tete) suite.push(base[m]);
    }

    var retenus = (tete ? [tete] : []).concat(suite).slice(0, 2);

    // La mention va sur CHAQUE article retenu qui franchit le palier, pas
    // seulement sur le premier. Deux articles a 34,90 et 49,90 debloquent
    // tous deux un palier a 30,10 : n'en signaler qu'un laisse croire que
    // l'autre ne compte pas, et le client choisit moins bien.
    for (var q = 0; q < retenus.length; q++) {
      if (retenus[q].centimes >= ecart.montant) retenus[q].note = ecart.libelle;
    }
    return retenus;
  }

  function carteReco(p) {
    var visuel = p.image ? p.image + (p.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : '';
    // Toujours un ajout, jamais un renvoi vers la fiche : envoyer le client
    // ailleurs pour le reconvaincre a zero fait perdre le benefice du
    // palier qu'on vient de lui montrer. Le titre et l'image restent des
    // liens pour qui veut regarder le produit avant ou apres.
    var action = '<button type="button" class="sc-reco__action" data-sc-reco="' + p.variante + '">Ajouter</button>';
    return '<li class="sc-reco">' +
      (visuel ? '<a class="sc-reco__visuel" href="' + p.url + '"><img src="' + echapper(visuel) + '" alt="" loading="lazy" width="56" height="56"></a>' : '') +
      '<div class="sc-reco__infos">' +
        '<a class="sc-reco__titre" href="' + p.url + '">' + echapper(p.titre) + '</a>' +
        (p.note ? '<span class="sc-reco__note">' + echapper(p.note) + '</span>' : '') +
        '<span class="sc-reco__prix">' + prix(p.centimes) + '</span>' +
      '</div>' + action +
    '</li>';
  }

  function recommander(panier) {
    if (!zoneReco) return;
    if (!panier.item_count) { zoneReco.hidden = true; zoneReco.innerHTML = ''; return; }

    var cibles = familleDe(panier);

    // Les deux premieres cibles sont chargees en parallele : la regle du
    // palier n'a d'interet que si elle a un vrai vivier a arbitrer. Les
    // cibles suivantes ne sont sollicitees que si le vivier reste trop
    // maigre, et les reponses sont gardees en cache pour la session.
    var accumule = [];
    var suite = Promise.all([
      chargerCollection(cibles[0]),
      cibles[1] ? chargerCollection(cibles[1]) : Promise.resolve([])
    ]).then(function (paquets) {
      accumule = paquets[0].concat(paquets[1]);
    });

    cibles.slice(2).forEach(function (handle) {
      suite = suite.then(function () {
        if (choisir(accumule, panier).length >= 2) return;
        return chargerCollection(handle).then(function (liste) {
          accumule = accumule.concat(liste);
        });
      });
    });

    return suite.then(function () {
      var retenus = choisir(accumule, panier);
      if (!retenus.length) { zoneReco.hidden = true; zoneReco.innerHTML = ''; return; }
      var html = '<p class="sc-panier__upsell-titre">Compl\u00e9tez votre confort</p><ul class="sc-panier__recos" role="list">';
      for (var i = 0; i < retenus.length; i++) html += carteReco(retenus[i]);
      zoneReco.innerHTML = html + '</ul>';
      zoneReco.hidden = false;
    });
  }

  function ajouterReco(varianteId, bouton) {
    if (recoEnCours) return;
    recoEnCours = true;
    if (bouton) { bouton.disabled = true; bouton.textContent = '...'; }
    ajouter([{ id: varianteId, quantity: 1 }])
      .then(function () { return lire().then(rendre); })
      // Echec : la fiche produit reste un chemin d'achat valable.
      .catch(function () { window.location.href = URL_PANIER; })
      .then(function () { recoEnCours = false; });
  }



  /* ------------------------------------------------------------------ */
  /* Vivier des cadeaux                                                  */
  /* ------------------------------------------------------------------ */
  //
  // L'eligibilite n'est jamais une liste ecrite en dur : elle se recalcule
  // a chaque appel a partir des collections et du plafond. Un article ajoute
  // demain a 18 EUR dans « figurines » ne sera jamais offert sans que
  // personne n'ait a y penser — et c'est le gabarit cote serveur qui
  // applique le plafond, pas ce script.
  var vivierCadeaux = null;   // promesse, resolue une seule fois par session

  function chargerVivier() {
    if (vivierCadeaux) return vivierCadeaux;
    if (!COLLECTIONS_CADEAU.length) return Promise.resolve([]);

    vivierCadeaux = Promise.all(COLLECTIONS_CADEAU.map(function (handle) {
      return fetch('/collections/' + handle + '?view=cadeaux', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { j = null; }
          if (!j || !j.produits) return null;
          return { handle: handle, titre: j.collection, produits: j.produits };
        })
        .catch(function () { return null; });
    })).then(function (paquets) {
      var familles = paquets.filter(function (f) { return f && f.produits.length; });
      // Une collection vide n'est pas une erreur : elle disparait
      // simplement des onglets.
      return familles;
    });
    return vivierCadeaux;
  }

  // Cadeau propose d'office : le premier article de la premiere collection
  // qui en contient. L'ordre des collections dans l'editeur est donc
  // l'ordre de priorite, et il se change sans toucher au code.
  function cadeauParDefaut(familles) {
    for (var i = 0; i < familles.length; i++) {
      if (familles[i].produits.length) return familles[i].produits[0];
    }
    return null;
  }
  /* ------------------------------------------------------------------ */
  /* Cadeau du premier palier                                            */
  /* ------------------------------------------------------------------ */
  //
  // Le seuil se calcule sur le panier HORS cadeau. Si le cadeau portait un
  // prix, le compter dans le total ferait qu'il se maintiendrait lui-meme
  // au-dessus du palier : le client descendrait a 70 euros et garderait un
  // cadeau auquel il n'a plus droit.
  //
  // Rien ici ne cree de gratuite : c'est une reduction automatique Shopify
  // qui met le prix a zero. Ce code ne fait qu'ajouter et retirer la ligne.
  function estLigneCadeau(item) {
    return !!(item.properties && item.properties[MARQUE_CADEAU]);
  }

  // Offert veut dire remise a zero, pas simplement marque comme cadeau.
  // On regarde la remise de LIGNE : la remise de commande, elle, est
  // repartie sur toutes les lignes et n'a rien a voir avec le cadeau.
  function cadeauEffectivementOffert(item) {
    var brut = item.original_line_price != null ? item.original_line_price : item.final_line_price;
    return (item.line_level_total_discount || 0) >= brut;
  }

  function ligneCadeau(panier) {
    for (var i = 0; i < panier.items.length; i++) {
      if (estLigneCadeau(panier.items[i])) return panier.items[i];
    }
    return null;
  }

  // Base de calcul des paliers : le montant REELLEMENT paye, hors cadeaux.
  //
  // Ni original_line_price ni final_line_price ne conviennent seuls :
  //
  //   - original_line_price ignore les remises WideBundle. Deux housses a
  //     89,90 EUR seraient comptees 99,80 : la barre annoncerait un palier
  //     que le client n'a pas atteint, et le cadeau disparaitrait au moment
  //     de payer.
  //   - final_line_price serait juste aujourd'hui, mais une remise de
  //     COMMANDE est repartie sur les lignes par Shopify selon le contexte.
  //     Si elle s'y glissait, un panier a 140 EUR debloquerait les 10 EUR,
  //     retomberait a 130, les perdrait, les reprendrait.
  //
  // On soustrait donc explicitement les seules remises de LIGNE. Verifie sur
  // un panier reel : original_line_price - line_level_total_discount tombe au
  // centime sur final_line_price.
  // 04/09/2026 — deux fonctions ont disparu d'ici : cadeauGonfleraitLePalier
  // et remiseDeCommandeCouvre. Elles servaient a decider s'il fallait
  // reprendre un cadeau devenu couteux. Le vivier etant passe a des
  // variantes a 0,00 EUR, la question ne se pose plus.

  function totalHorsCadeau(panier) {
    var somme = 0;
    for (var i = 0; i < panier.items.length; i++) {
      var it = panier.items[i];
      if (estLigneCadeau(it)) continue;

      var brut = it.original_line_price != null ? it.original_line_price : it.final_line_price;
      var remiseDeLigne = it.line_level_total_discount != null
        ? it.line_level_total_discount
        : 0;
      somme += brut - remiseDeLigne;
    }
    return somme;
  }

  function ajouterCadeau(produit) {
    var proprietes = {};
    proprietes[MARQUE_CADEAU] = 'Palier ' + prix(PALIER_CADEAU);
    return ajouter([{ id: produit.variante, quantity: 1, properties: proprietes }]);
  }

  function gererCadeau(panier) {
    if (!PALIER_CADEAU || !COLLECTIONS_CADEAU.length || cadeauEnCours) {
      return Promise.resolve(false);
    }

    var actuel = ligneCadeau(panier);
    var base = totalHorsCadeau(panier);
    var duAuClient = base >= PALIER_CADEAU;

    // 04/09/2026 — cadeau herite d'avant le passage aux variantes a 0 EUR.
    //
    // Les paniers ouverts avant la refonte contiennent un VRAI produit marque
    // comme cadeau, que la remise BXGY rendait gratuit. Cette remise a ete
    // supprimee : la ligne est desormais FACTUREE, sous une etiquette
    // « Offert ». Mesure faite sur un panier reconstitue : 14,99 EUR ajoutes
    // au total, sans aucune remise.
    //
    // On retire donc toute ligne cadeau qui porte un prix. Le flux normal,
    // juste en dessous, repose aussitot le cadeau a 0 EUR : le client ne perd
    // rien, il cesse simplement de payer ce qu'on lui offre.
    if (actuel && actuel.original_line_price > 0) {
      cadeauEnCours = true;
      return changer(actuel.key, 0)
        .then(function () { return true; })
        .catch(function () { return false; })
        .then(function (change) { cadeauEnCours = false; return change; });
    }


    // Cadeau present mais pas remis a zero. Cela arrive dans une bande
    // etroite sous le second palier : offrir le cadeau ferait repasser le
    // sous-total sous le seuil des 10 EUR, et Shopify retient alors la
    // reduction la plus avantageuse pour le client — la remise de commande.
    //
    // Dans ce cas le client est GAGNANT en gardant le cadeau : il paie
    // 10 EUR de moins et repart quand meme avec l'article. Le lui retirer
    // parce qu'il vient de depenser plus serait absurde, et c'est ce que
    // faisait la version precedente. On ne le retire que si aucune remise
    // de commande ne vient le couvrir — la, il paierait vraiment pour un
    // cadeau qu'il n'a pas demande.
    // Deux raisons de reprendre un cadeau deja pose :
    //   - il ferait franchir le second palier a la place du client ;
    //   - il est facture sans qu'aucune remise ne le couvre.
    // Dans les deux cas, le garder couterait plus que la deception de le
    // voir repartir — et la barre explique aussitot qu'il revient, avec la
    // remise, au palier suivant.
    // 04/09/2026 — un cadeau pose n'est PLUS JAMAIS repris tant que le
    // client garde son palier.
    //
    // Ce bloc reprenait le cadeau dans deux cas : quand il aurait fait
    // franchir le second palier a la place du client, et quand il n'etait
    // plus offert. Les deux venaient de la meme cause : le cadeau portait un
    // prix reel, ramene a zero par une remise. Il pesait donc dans le seuil
    // des 140 EUR, et perdait sa gratuite des que la remise de commande
    // prenait le pas sur la remise cadeau.
    //
    // Le vivier est desormais fait de variantes a 0,00 EUR. Le cadeau ne
    // pese plus rien, ne depend plus d'aucune remise, et il n'y a donc plus
    // aucune raison de le retirer. C'etait la cause des bugs 1 et 3 signales
    // en production : selecteur fige sur le cadeau par defaut au-dessus de
    // 140 EUR, et cadeau qui disparaissait en approchant ce palier.

    if (duAuClient && !actuel) {
      cadeauEnCours = true;
      return chargerVivier()
        .then(function (familles) {
          var choix = cadeauParDefaut(familles);
          // Aucun article eligible : le palier reste annonce, mais on
          // n'invente pas un cadeau. Mieux vaut ne rien ajouter qu'ajouter
          // n'importe quoi.
          if (!choix) return false;

          // Plus de garde ici : a 0,00 EUR, le cadeau ne peut plus faire
          // franchir aucun seuil a la place du client.
          return ajouterCadeau(choix).then(function () { return true; });
        })
        .catch(function () { return false; })
        .then(function (change) { cadeauEnCours = false; return change; });
    }

    var lignesCadeau = 0;
    for (var n = 0; n < panier.items.length; n++) {
      if (estLigneCadeau(panier.items[n])) lignesCadeau++;
    }

    var action = null;
    if (!duAuClient && actuel) {
      action = changer(actuel.key, 0);
    } else if (actuel && (lignesCadeau > 1 || actuel.quantity > 1)) {
      // Un cadeau, pas deux. On regarde le nombre de LIGNES autant que la
      // quantite : l'ancien defaut produisait des lignes distinctes, que
      // tester la seule quantite laissait passer.
      action = nettoyerCadeaux(actuel.variant_id);
    }
    if (!action) return Promise.resolve(false);

    cadeauEnCours = true;
    return action
      .then(function () { return true; })
      // Un cadeau qu'on n'arrive pas a poser ne doit jamais bloquer l'achat.
      .catch(function () { return false; })
      .then(function (change) { cadeauEnCours = false; return change; });
  }

  // Echange : on AJOUTE le nouveau avant de retirer l'ancien. L'ordre
  // inverse laisserait, entre les deux appels, un panier au-dessus du
  // palier sans cadeau — et gererCadeau y remettrait aussitot le cadeau par
  // defaut, annulant le choix du client. Le drapeau cadeauEnCours ferme la
  // porte pendant toute la manoeuvre.
  // Balayage : une seule ligne cadeau, et une seule unite.
  //
  // Mesure du 04/09/2026 : une cle de ligne relevee AVANT une mutation du
  // panier n'est plus valide APRES. Shopify repond alors 400 (« Pas
  // d'identifiant ou de parametre de ligne valide ») et le retrait echoue en
  // silence. C'est ce qui empilait les cadeaux : 1, puis 2, puis 3, puis 4
  // lignes sur trois changements. On relit donc le panier entre CHAQUE
  // retrait, au lieu de travailler sur une liste figee.
  //
  // Le balayage est idempotent : il rattrape aussi les paniers deja pollues
  // par l'ancien defaut, sans script de migration separe.
  function nettoyerCadeaux(varianteAGarder) {
    var garde = varianteAGarder != null ? String(varianteAGarder) : null;

    // Borne dure : douze passages suffisent tres largement, et aucune
    // reponse inattendue du serveur ne peut transformer ce nettoyage en
    // boucle infinie sur le panier d'un client.
    function passe(reste) {
      if (reste <= 0) return lire();
      return lire().then(function (panier) {
        var cadeaux = [];
        for (var i = 0; i < panier.items.length; i++) {
          if (estLigneCadeau(panier.items[i])) cadeaux.push(panier.items[i]);
        }
        if (!cadeaux.length) return panier;

        // Celui qu'on garde : la variante demandee si elle est la, sinon la
        // premiere. Ne jamais tout supprimer — le client se retrouverait
        // sans cadeau alors qu'il y a droit.
        var aGarder = null;
        if (garde) {
          for (var j = 0; j < cadeaux.length; j++) {
            if (String(cadeaux[j].variant_id) === garde) { aGarder = cadeaux[j]; break; }
          }
        }
        if (!aGarder) aGarder = cadeaux[0];

        for (var k = 0; k < cadeaux.length; k++) {
          if (cadeaux[k].key !== aGarder.key) {
            return changer(cadeaux[k].key, 0).then(function () { return passe(reste - 1); });
          }
        }
        if (aGarder.quantity > 1) {
          return changer(aGarder.key, 1).then(function () { return passe(reste - 1); });
        }
        return panier;
      });
    }
    return passe(12);
  }

  function echangerCadeau(produit) {
    if (cadeauEnCours) return;
    cadeauEnCours = true;
    racine.classList.add('is--occupe');

    lire()
      .then(function (panier) {
        var ancien = ligneCadeau(panier);
        // Deja le bon cadeau : on ne touche a rien, mais on balaie quand
        // meme, au cas ou des doublons traineraient d'une session anterieure.
        if (ancien && String(ancien.variant_id) === String(produit.variante)) {
          return nettoyerCadeaux(produit.variante);
        }
        // On ajoute d'abord : l'ordre inverse laisserait, entre les deux
        // appels, un panier au-dessus du palier sans cadeau, et gererCadeau y
        // remettrait aussitot le cadeau par defaut.
        //
        // Le retrait de l'ancien n'utilise PLUS la cle relevee ci-dessus :
        // elle est perimee des que l'ajout a eu lieu. Le balayage relit le
        // panier et retire tout ce qui n'est pas la variante choisie.
        return ajouterCadeau(produit).then(function () {
          return nettoyerCadeaux(produit.variante);
        });
      })
      .then(function () { return lire(); })
      .then(function (panier) {
        cadeauEnCours = false;
        rendre(panier);
        rendreCadeaux(panier);
      })
      .catch(function () {
        cadeauEnCours = false;
        // On relit pour repartir de l'etat reel du serveur plutot que de
        // laisser l'affichage sur une hypothese.
        lire().then(rendre).catch(function () {});
      })
      .then(function () { racine.classList.remove('is--occupe'); });
  }



  /* ------------------------------------------------------------------ */
  /* Panneau de choix du cadeau                                          */
  /* ------------------------------------------------------------------ */
  var zoneCadeaux = racine.querySelector('[data-sc-cadeaux]');
  var zoneOnglets = racine.querySelector('[data-sc-cadeaux-onglets]');
  var zoneListe = racine.querySelector('[data-sc-cadeaux-liste]');
  var zoneIntro = racine.querySelector('[data-sc-cadeaux-intro]');
  var familleActive = 0;
  var varianteRetenue = null;   // variante actuellement offerte, pour la cocher

  function rendreCadeaux(panier) {
    if (!zoneCadeaux) return;
    var actuel = panier ? ligneCadeau(panier) : null;
    varianteRetenue = actuel ? String(actuel.variant_id) : null;

    return chargerVivier().then(function (familles) {
      if (!familles.length) {
        zoneListe.innerHTML = '<p class="sc-cadeaux__vide">Aucun cadeau disponible pour le moment.</p>';
        zoneOnglets.innerHTML = '';
        return;
      }
      if (familleActive >= familles.length) familleActive = 0;

      if (zoneIntro) {
        zoneIntro.textContent = 'Offert dès ' + prixCourt(PALIER_CADEAU) +
          ' d\u2019achat. Changez d\u2019avis autant de fois que vous voulez.';
      }

      var onglets = '';
      for (var f = 0; f < familles.length; f++) {
        onglets += '<button type="button" role="tab" class="sc-cadeaux__onglet' +
          (f === familleActive ? ' is--actif' : '') + '" data-sc-cadeaux-onglet="' + f + '"' +
          ' aria-selected="' + (f === familleActive ? 'true' : 'false') + '">' +
          echapper(nomCourt(familles[f].titre)) +
          '<span class="sc-cadeaux__compte">' + familles[f].produits.length + '</span>' +
        '</button>';
      }
      zoneOnglets.innerHTML = onglets;

      var produits = familles[familleActive].produits;
      var cartes = '';
      for (var i = 0; i < produits.length; i++) {
        var prod = produits[i];
        var choisi = varianteRetenue && String(prod.variante) === varianteRetenue;
        cartes += '<button type="button" class="sc-cadeau' + (choisi ? ' is--choisi' : '') +
          '" data-sc-cadeau="' + prod.variante + '" data-famille="' + familleActive + '">' +
          '<span class="sc-cadeau__visuel">' +
            (prod.image ? '<img src="' + echapper(prod.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
            (choisi ? '<span class="sc-cadeau__coche">' + ICONE_COCHE + '</span>' : '') +
          '</span>' +
          '<span class="sc-cadeau__titre">' + echapper(prod.titre) + '</span>' +
          '<span class="sc-cadeau__prix"><s>' + prix(prod.prix) + '</s> Offert</span>' +
        '</button>';
      }
      zoneListe.innerHTML = cartes;
      zoneListe.scrollTop = 0;
    });
  }

  // « FIGURINE VOITURE » sur un onglet de 100 pixels ne tient pas, et le mot
  // « voiture » n'apprend rien a quelqu'un qui est deja sur SylverCar.
  function nomCourt(titre) {
    var t = String(titre || '').replace(/\s*voiture\s*/gi, ' ').replace(/\s+/g, ' ').trim();
    if (!t) t = titre;
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  function ouvrirCadeaux() {
    if (!zoneCadeaux) return;
    zoneCadeaux.hidden = false;
    // Le retrait de l'attribut et l'ajout de la classe doivent etre separes
    // par un calcul de style, sinon le navigateur n'a pas d'etat de depart a
    // animer et le panneau apparait d'un coup.
    //
    // Lecture forcee plutot que requestAnimationFrame : rAF ne s'execute pas
    // quand l'onglet n'est pas au premier plan, et le panneau restait alors
    // hors de l'ecran. Une ouverture ne doit dependre d'aucune condition
    // d'affichage.
    void zoneCadeaux.offsetWidth;
    zoneCadeaux.classList.add('is--ouvert');
    var retour = zoneCadeaux.querySelector('[data-sc-cadeaux-retour]');
    if (retour) retour.focus();
  }

  function fermerCadeaux() {
    if (!zoneCadeaux) return;
    zoneCadeaux.classList.remove('is--ouvert');
    setTimeout(function () { zoneCadeaux.hidden = true; }, 320);
  }
  /* ------------------------------------------------------------------ */
  /* Filet de securite : toute mutation du panier ouvre le tiroir         */
  /* ------------------------------------------------------------------ */
  //
  // Une fiche produit porte quatre boutons « Ajouter au panier », dont
  // trois hors de tout formulaire : la barre collante du theme, le bouton
  // de l'offre groupee, un lien de carte. Intercepter leurs selecteurs un
  // par un donnerait une liste fausse des la prochaine application
  // installee.
  //
  // On ecoute donc la seule chose qu'ils ont tous en commun : l'appel
  // reseau au panier. Peu importe qui ajoute et comment, des que le panier
  // change le tiroir s'ouvre. Aucun appel n'est bloque ni modifie : on
  // observe, puis on reagit.
  var CHEMINS_PANIER = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // Seul un AJOUT ouvre le tiroir.
  //
  // Les scripts de suivi ecrivent leurs identifiants dans les attributs du
  // panier via /cart/update.js a chaque chargement de page. Traiter cela
  // comme un geste d'achat ouvrait le tiroir a chaque navigation, ce qui
  // rendait la boutique penible a parcourir. Une modification ou une
  // ecriture d'attributs rafraichit le contenu, sans jamais s'imposer.
  var CHEMIN_AJOUT = /\/cart\/add(\.js)?(\?|$)/;

  function estNotreAppel(options) {
    if (!options || !options.headers) return false;
    var h = options.headers;
    if (typeof h.get === 'function') return !!h.get('X-SylverCar-Panier');
    return !!(h['X-SylverCar-Panier'] || h['x-sylvercar-panier']);
  }

  function reagirAuChangement(estUnAjout) {
    // Un court delai laisse l'application qui vient d'ecrire finir son
    // travail : certaines enchainent add puis change pour poser une
    // propriete de ligne, et lire trop tot afficherait un panier a moitie
    // constitue.
    //
    // Si un ajout survient pendant ce delai, il l'emporte : plusieurs appels
    // peuvent se suivre, un seul geste d'achat suffit a justifier
    // l'ouverture.
    if (estUnAjout) reagirAuChangement.ouvrir = true;
    clearTimeout(reagirAuChangement.minuteur);
    reagirAuChangement.minuteur = setTimeout(function () {
      var ouvrirLeTiroir = reagirAuChangement.ouvrir;
      reagirAuChangement.ouvrir = false;
      if (ouvrirLeTiroir) {
        rafraichirPuisOuvrir().catch(function () { /* le lien natif reste */ });
      } else {
        lire().then(rendre).catch(function () { /* rien de visible a faire */ });
      }
    }, 220);
  }

  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (entree, options) {
      var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
      var promesse = fetchOrigine.apply(this, arguments);
      if (CHEMINS_PANIER.test(String(url)) && !estNotreAppel(options)) {
        var estUnAjout = CHEMIN_AJOUT.test(String(url));
        promesse.then(function (r) {
          if (r && r.ok) reagirAuChangement(estUnAjout);
        }).catch(function () { /* l'appelant gere son propre echec */ });
      }
      return promesse;
    };
  }

  // Certaines applications passent encore par XMLHttpRequest.
  var ouvrirXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__scUrlPanier = CHEMINS_PANIER.test(String(url || ''));
    this.__scEstAjout = CHEMIN_AJOUT.test(String(url || ''));
    return ouvrirXHR.apply(this, arguments);
  };
  var envoyerXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var requete = this;
    if (requete.__scUrlPanier) {
      requete.addEventListener('load', function () {
        if (requete.status >= 200 && requete.status < 300) reagirAuChangement(requete.__scEstAjout);
      });
    }
    return envoyerXHR.apply(this, arguments);
  };

  // Dernier trou : form.submit() appele par un script ne declenche AUCUN
  // evenement submit, il quitte donc la page vers /cart sans que rien ne
  // puisse l'intercepter. On detourne les seuls formulaires d'ajout, et
  // uniquement quand notre chemin AJAX est disponible.
  var soumettreOrigine = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    var action = this.getAttribute('action') || '';
    if (action.indexOf('/cart/add') >= 0 && !this.__scRepli) {
      soumettre(this);
      return;
    }
    return soumettreOrigine.apply(this, arguments);
  };


  /* ------------------------------------------------------------------ */
  /* WideBundle : forcer le mode « rester sur la page »                  */
  /* ------------------------------------------------------------------ */
  //
  // WideBundle propose trois comportements apres ajout, et le reglage est
  // enregistre OFFRE PAR OFFRE dans son administration — il n'existe pas de
  // reglage global. Avec des dizaines de bundles, le passer a la main sur
  // chacun serait long et surtout impossible a garantir dans le temps : il
  // suffirait d'oublier une offre creee plus tard pour que le client soit
  // ejecte du tunnel vers /cart.
  //
  // L'application lit ce reglage DANS LA PAGE au moment du clic. On le force
  // donc ici, une fois, pour toutes les offres :
  //
  //   'cart'     -> WideBundle ajoute puis quitte la page vers /cart
  //   'checkout' -> WideBundle ajoute puis file au paiement
  //   'form'     -> WideBundle injecte ses variantes dans le formulaire du
  //                 theme puis clique le bouton d'ajout du theme
  //
  // Le mode 'form' est celui qui nous convient : notre interception recupere
  // le formulaire avec TOUTES ses variantes, l'ajout se fait en arriere-plan
  // et le tiroir s'ouvre. Verifie sur une offre « 2 housses » : deux
  // exemplaires au panier, remise de 9,90 EUR conservee, aucune redirection.
  //
  // Si WideBundle changeait un jour le nom de ce reglage, ce forcage
  // deviendrait sans effet et l'application reprendrait son comportement
  // d'origine — genant, mais jamais dangereux : le panier resterait juste.
  // Le repli serait alors de repasser chaque offre en « panier lateral »
  // dans son administration.
  (function forcerModeWideBundle() {
    var essais = 0;
    var horloge = setInterval(function () {
      essais++;
      var wb = window.wideBundle;
      if (wb && wb.settings) {
        wb.settings.link_choice = 'form';
        clearInterval(horloge);
        return;
      }
      // Une trentaine de secondes suffisent largement : au-dela, c'est que
      // l'application n'est pas sur cette page, et il n'y a rien a forcer.
      if (essais > 150) clearInterval(horloge);
    }, 200);
  })();

  // Etat initial : on peuple le tiroir sans l'ouvrir, pour que le compteur
  // et les totaux soient justes des le premier clic.
  lire().then(rendre).catch(function () { /* le lien natif suffit */ });
})();
